<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Call Logs</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getAppSupportCallLog($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <TabView v-if="userdatadisplayflag">
        <TabPanel header="Call Log">
            <div class="card">
                <DataTable :value="goingCallLogs" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="goingCallCount" :loading="loading" @page="onPageChange" class="p-datatable-users"
                    data-key="ld1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column field="id" header="Sr." headerStyle="width: 4%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column field="datatime" header="Date Time" headerStyle="width: 15%" bodyStyle="width: 13%">
                        <template #body="{ data }">
                            <div>
                                {{ format_datetime(data.datetime) }}
                            </div>
                        </template>
                    </Column>
                    <Column field="callernumber" header="Called Number" headerStyle="width: 13%"
                        bodyStyle="width: 13%">
                        <template #body="{ data }">
                            <div class="text-capitalize p-mb-1"><Button icon="pi pi-phone"
                                        v-tooltip.left="'Click To Call'" class="ticket-custom-call-btn p-button-success"
                                        @click="triggerCallToMeraNetaClients(data)"
                                        v-if="data.lj8 != '' && data.lj8 != null" :disabled="isDisabled">
                                    </Button><span v-if="data.lj7">+{{data.lj7}} </span> {{ data.lj8 ? this.allow_to_display_mobile_number == 0 ? maskMobileNumber(data.lj8) : data.lj8 : "N/A" }}</div>
                            <div class="p-text-capitalize ">{{ data.lj29 ? data.lj29 : "N/A" }}</div>
                        </template>
                    </Column>
                    <Column field="callstatus" header="Call Status" headerStyle="width: 10%" bodyStyle="width: 10%">
                        <template #body="{ data }">
                            <span>{{ data.lj16 ? data.lj16 : "N/A" }}</span>
                        </template>
                    </Column>
                    <Column field="callby" header="Call By" headerStyle="width: 12%" bodyStyle="width: 12%">
                        <template #body="{ data }">
                            <div>{{ data.lj15 ? this.allow_to_display_mobile_number == 0 ? maskMobileNumber(data.lj15) : data.lj15 : "N/A" }}
                                <div class="p-text-capitalize ">{{ data.lj28 ? data.lj28 : "N/A" }}</div>
                            </div>
                        </template>
                    </Column>
                    <Column field="callduration" header="Call Duration" headerStyle="width: 8%" bodyStyle="width: 8%">
                        <template #body="{ data }">
                            <span>{{ data.lj14 ? data.lj14 : "00:00:00" }}</span>
                        </template>
                    </Column>
                    <Column field="billduration" header="Bill Duration" headerStyle="width: 8%" bodyStyle="width: 8%">
                        <template #body="{ data }">
                            <span>{{ data.lj34 ? data.lj34 : "00:00:00" }}</span>
                        </template>
                    </Column>
                    <Column field="recording" header="Recording" headerStyle="width: 8%" bodyStyle="width: 8%">
                    <template #body="{ data }">
                        <a v-if="data.lj18 != '' && data.lj18 != null" class="download-btn" target="_blank" :href="data.lj18">
                            <i class="pi pi-download" style="margin-left: 2px;"></i>
                        </a>
                        <span v-if="data.lj18 == '' || data.lj18 == null">N/A</span>
                    </template>
                </Column>
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
</template>
<script>
import ApiService from '../../service/ApiService';
import moment from 'moment';
import CommonMixins from '../../mixins/common-mixins';


export default {
    mixins: [CommonMixins],
    data() {
        return {
            adminList: [],
            page_no: 0,
            goingCallCount: 0,
            loading: false,
            goingCallLogs: [],
            emp_name: '',
            userdatadisplayflag: false,
            admin_id: '',
            admin_list_status: false,
            itemsPerPage: 30,
            searchnamebtnactive: false,
            hidesearchname: false,
            searchfullname: '',
            searchnameloader: false,
            activate_read_key_arr: [],
            allow_to_display_mobile_number: 0,


        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.storage_path = JSON.parse(localStorage.masterBucketName);
        const localdata = JSON.parse(localStorage.user);
        this.allow_to_display_mobile_number = localdata.allow_to_display_mobile_number;
        if (this.$store.state.adminId != null) {
            this.admin_id = this.$store.state.adminId;
            let adminId = this.$store.state.adminId;
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    let emp_name_id = data.data.records.filter(function (item) {
                        return item.value == adminId;
                    });
                    if (emp_name_id.length > 0) {
                        this.emp_name = emp_name_id[0];
                    }
                    this.getAppSupportCallLog();
                } else {
                    this.adminList = null;
                }
            });
        } else {
            this.getAdminListOnly();
        }
    },

    methods: {
        triggerCallToMeraNetaClients(data) {
            this.isDisabled = true;
            this.ApiService.triggercalltomeranetaclients({ mobile_number: data.lj8, sa4: data.lj21, sa30: data.lj9, sa31: data.lj29 }).then(
                (items) => {
                    if (items.success === true) {
                        this.isDisabled = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                    } else {
                        this.isDisabled = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                }
            );
        },
        getAdminListOnly(e) {
            this.ApiService.getAdminListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    if (data.data.records.length == 1) {
                        this.getAppSupportCallLog({ value: data.data.records[0] });
                        this.emp_name = data.data.records[0];
                    }
                } else {
                    this.adminList = null;
                }
            });
        },
        getAppSupportCallLog(e) {
            this.userdatadisplayflag = true;
            this.loading = true;
            if (e) {
                this.admin_id = e.value.value;
            }
            this.activate_read_key_arr = [];
            this.ApiService.getAppSupportCallLog({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.goingCallLogs = data.data;
                    this.goingCallCount = data.count;
                    this.loading = false;
                    this.admin_list_status = true;

                    this.searchnameloader = false;
                    // this.searchmobloader = false;
                    this.hidesearchname = false;
                    this.hidesearchmob = false;
                }
            });
        },
        activateReadMore(e) {
            this.activate_read_key_arr.push(e);
        },

        deactivateReadMore(e) {
            var index = this.activate_read_key_arr.indexOf(e);
            if (index !== -1) {
                this.activate_read_key_arr.splice(index, 1);
            }
        },
        onPageChange(e) {
            this.loading = true;
            if (this.admin_list_status) {
                this.page_no = e.page;
                this.getAppSupportCallLog();
            }
        },
        searchFnameVoter(searchfullname) {
            this.hidesearchname = true;
            this.searchnameloader = true;
            this.lr14 = searchfullname;
            this.getAppSupportCallLog({
                page_no: this.page_no,
                lr14: this.lr14,
            });
            this.searchnamebtnactive = true;
        },
        searchNameVoterStop() {
            this.searchnamebtnactive = false;
            this.searchfullname = "";
            this.getAppSupportCallLog({
                page_no: this.page_no,
            });
            this.searchnameloader = false;
        },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return 'N/A';
            }
        },

        replacebrake(html) {
            const doc = html;
            return doc.replace(/(\r)*\n/g, '<br>');
        },
        decodeHtml(html) {
            return JSON.parse('"' + html + '"');
        },
        format_datetime(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return '-';
            }
        },
    },
};
</script>
<style scoped lang="scss">
.custom-form-group {
    display: flex;
    align-items: center;
}
.download-btn {
    padding: 10px;
    border-radius: 50%;
    height: 2.75rem;
    color: #ffffff;
    background: #3c6895;
    border: 0 none;
    width: 38.5px;
    display: inline-block;
}
</style>
